import { CompanyFeature } from '~/use-cases/types/CompanyFeature';
import { PaymentMode } from '~/use-cases/types/PaymentMode';
import { MagicUseCase } from './magicUseCase';

export class InitializePaymentModeUseCase extends MagicUseCase {
  protected async runLogic() {
    const features = this.getState().user.companyInfo?.features ?? [];
    this.getState().user.paymentMode = features.includes(CompanyFeature.CentralizedPayments) ? PaymentMode.Pay : PaymentMode.Portal;
  }
}
